import "@/styles/main.scss";

import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    iconfont: "mdi",
  },
  styles: {
    configFile: "@/styles/settings.scss",
  },
  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          muted: "#64748b",
          primary: "#212427",
          primaryLight: "#3a3d40",
          primaryDark: "#0b0d10",
          secondary: "#67d6fa",
          accent: "#cfb8ff",
          error: "#fa7a68",
          info: "#ffd978",
          success: "#c9fa75",
          button: "#D3F987",
          buttonGreen: "#D3F987",
          warning: "#b6b6b6",
          smoke: "#FAFAFA",
          smokeDark: "#F5F5F5",
          dark: "#191919",
          facebook: "#1877F2",
          instagram: "#C13584",
          linkedin: "#0072b1",
          pink: "#E2BAC2",
          faded: "#5C5C5C",
          buttonGrey: "D8D8D8",
          teal: "#42b6c6",
        },
      },
    },
  },
});

export default vuetify;
